import { useQuery } from '@tanstack/react-query';
import { getRecipientSuggestions } from '@/api/messaging-api';

export const recipientSuggestionKeys = {
  all: ['recipient-suggestions'] as const,
  query: (q: string) => [...recipientSuggestionKeys.all, q] as const,
};

export function useRecipientSuggestions(query: string, opts?: { enabled?: boolean }) {
  const trimmed = query.trim();
  return useQuery({
    queryKey: recipientSuggestionKeys.query(trimmed),
    queryFn: () => getRecipientSuggestions(trimmed),
    enabled: (opts?.enabled ?? true) && trimmed.length >= 1,
    staleTime: 5 * 60 * 1000,
    placeholderData: (prev) => prev,
  });
}
